import { render, staticRenderFns } from "./detailsSeckillAct.vue?vue&type=template&id=0a936517&scoped=true&"
import script from "./detailsSeckillAct.vue?vue&type=script&lang=js&"
export * from "./detailsSeckillAct.vue?vue&type=script&lang=js&"
import style0 from "./detailsSeckillAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsSeckillAct.vue?vue&type=style&index=1&id=0a936517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a936517",
  null
  
)

component.options.__file = "detailsSeckillAct.vue"
export default component.exports